// @flow

// Actions
export const REOPEN_JOB = 'REOPEN_JOB'

// Message keys
export const MSG_REOPEN_JOB_TABLE_ROW_BTN = 'reopenJob.tableRowButton'
export const MSG_REOPEN_JOB_SIDEBAR_HEADING = 'reopenJob.sidebarHeading'
export const MSG_REOPEN_JOB_SIDEBAR_MESSAGE = 'reopenJob.sidebarMessage'
export const MSG_REOPEN_JOB_SIDEBAR_REOPEN_BTN = 'reopenJob.sidebarReopenButton'
export const MSG_REOPEN_JOB_SIDEBAR_CANCEL_BTN = 'reopenJob.sidebarCancelButton'
